import { render, staticRenderFns } from "./photo_list.vue?vue&type=template&id=64faefa7&scoped=true&"
import script from "./photo_list.vue?vue&type=script&lang=js&"
export * from "./photo_list.vue?vue&type=script&lang=js&"
import style0 from "./photo_list.vue?vue&type=style&index=0&id=64faefa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64faefa7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64faefa7')) {
      api.createRecord('64faefa7', component.options)
    } else {
      api.reload('64faefa7', component.options)
    }
    module.hot.accept("./photo_list.vue?vue&type=template&id=64faefa7&scoped=true&", function () {
      api.rerender('64faefa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/reports/banquet_present/form/photo_list.vue"
export default component.exports